import type { Step } from '@sb/remote-control/types';

/**
 * The routine a `CallSubroutine` step targets, or `undefined` when no target
 * is selected. An empty target reads as unselected, so callers can test the
 * result for truthiness alone.
 *
 * Takes the step's arguments rather than the step, so a caller that already
 * resolved them against the owning routine doesn't look them up twice.
 *
 * Identifies the target by the presence of `routineID`, NOT by
 * `argumentKind`. Stored step arguments do not reliably carry
 * `argumentKind`, so requiring it drops real subroutine references — see
 * the test that pins this.
 */
export function callSubroutineTargetId(
  args: Step.Arguments | undefined,
): string | undefined {
  if (!args || !('routineID' in args)) return undefined;

  return args.routineID || undefined;
}
